import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {browserHistory} from 'react-router'
import {Form} from 'react-form'
import ResetPasswordForm from './ResetPasswordForm'
import showToastr from '../../utils/showToastr'
import ErrorHandler from '../../utils/ErrorHandler'

import './Layout/ResetPassword.css'

class ResetPasswordScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      message: {status: '', context: ''},
      isLoading: false
    }
  }
  render () {
    const {message, isLoading} = this.state

    const onSubmit = (values) => {
      this.setState({isLoading: true})
      const form = {
        new_password: values.new_password,
        key: this.props.location.query.key
      }
      Actions.resetPassword(form).then((res) => {
        showToastr('success', 'تغییر رمز عبور', res.data.messages[0])
        this.setState({isLoading: false})
        browserHistory.push('/login')
      }).catch((err) => {
        let eh = new ErrorHandler(err)
        this.setState({message: eh.message, isLoading: false})
        eh.setFormErrors(this.refs.resetPasswordForm)
        eh.showToastrIn('تغییر رمز عبور')
      })
    }

    return (
      <Form
        ref="resetPasswordForm"
        message={message}
        validate={(values) => {
          let errors = {}
          if (!values.new_password) {
            errors.new_password = 'این فیلد الزامی است'
          }
          return errors
        }}
        defaultValues={{showPasswordIcon: true, type: 'password'}}
        disabled={isLoading}
        onSubmit={onSubmit}>
        {ResetPasswordForm}
      </Form>
    )
  }
}

export default ResetPasswordScreen



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordScreen.js